// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { creditCardDetailsEntryStyles } from "@steiner/Overrides/Widgets/CheckoutReviewAndSubmit/CreditCardDetailsEntry";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { css } from "styled-components";

creditCardDetailsEntryStyles.creditCardDetailsContainer = {
    gap: 16,
};

creditCardDetailsEntryStyles.creditCardDetailsHeading = {
    variant: "h5",
    css: css`
        margin-bottom: 0;
    `,
};

creditCardDetailsEntryStyles.cardNumberGridItem = {
    width: [12, 6, 6, 6, 6],
};

creditCardDetailsEntryStyles.securityCodeGridItem = {
    width: [12, 6, 6, 6, 6],
};

creditCardDetailsEntryStyles.hintContainer = {
    css: css`
        display: flex;
        justify-content: space-between;
        gap: 4px;
        width: 100%;
        & + span {
            display: none;
        }
    `,
};

creditCardDetailsEntryStyles.hintLink = {
    typographyProps: {
        size: fontConfig.fontSize.xSmall,
        lineHeight: fontConfig.lineHeight.xSmall,
    },
};

creditCardDetailsEntryStyles.cardNumberLabelStyle = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: center;
    `,
};

creditCardDetailsEntryStyles.creditCardTypeStyles = {
    container: {
        css: css`
            gap: 4px;
        `,
    },
    icon: {
        size: 19,
    },
};

creditCardDetailsEntryStyles.expirationMonthGridItem = {
    width: [12, 6, 6, 6, 6],
};

creditCardDetailsEntryStyles.expirationYearGridItem = {
    width: [12, 6, 6, 6, 6],
};

creditCardDetailsEntryStyles.expirationYearSelect = {
    cssOverrides: {
        formField: css`
            & > label {
                visibility: hidden;
            }
        `,
    },
};

creditCardDetailsEntryStyles.saveCardCheckbox = {
    typographyProps: {
        size: fontConfig.fontSize.xSmall,
        lineHeight: fontConfig.lineHeight.xSmall,
        css: css`
            line-height: ${fontConfig.lineHeight.xSmall};
        `,
    },
};
